<template>
    <div>
        <!-- 搜索框 -->
        <a-card title="系统注册">
            <a-button slot="extra" type="primary" @click="handleNewSys">新增</a-button>
            <a-button slot="extra" style="margin-left:10px;" type="primary" @click="refreshAppVersion">刷新系统版本</a-button>
            <a-form layout="inline" @submit="handleSubmit" :form="form">
                <a-form-model-item label="版本">
                    <a-select v-model="searchP.version" placeholder="" style="width: 80px">
                        <a-select-option value=""> 全部 </a-select-option>
                        <a-select-option value="V3.0"> 3.0 </a-select-option>
                        <a-select-option value="V5.0"> 5.0 </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-item label="系统编码">
                    <a-input v-model="searchP.syscode" placeholder="系统编码"></a-input>
                </a-form-item>
                <a-form-item label="系统名称">
                    <a-input v-model="searchP.sysname" placeholder="系统名称"></a-input>
                </a-form-item>
                <a-form-item label="负责人">
                    <a-input v-model="searchP.sysadmin" placeholder="系统名称"></a-input>
                </a-form-item>

                <a-form-model-item label="领域">
                    <a-select v-model="searchP.domain" placeholder="" style="width: 100px">
                        <a-select-option value=""> 全部 </a-select-option>
                        <a-select-option value="001"> 前台 </a-select-option>
                        <a-select-option value="002"> 中台 </a-select-option>
                        <a-select-option value="003"> 开放 </a-select-option>
                        <a-select-option value="004"> 基础 </a-select-option>
                    </a-select>
                </a-form-model-item>

                <a-form-item label="系统分类">
                    <a-select v-model="searchP.syscategory" placeholder="" style="width: 150px">
                        <a-select-option value=""> 全部 </a-select-option>
                        <a-select-option value="Window"> Window </a-select-option>
                        <a-select-option value="Android"> Android </a-select-option>
                        <a-select-option value="IOS"> IOS </a-select-option>
                        <a-select-option value="JAVA-SERVER"> JAVA-SERVER </a-select-option>
                        <a-select-option value="H5"> H5 </a-select-option>
                        <a-select-option value="API"> API </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="所属组织">
                    <a-select v-model="searchP.ownercode" placeholder="" style="width: 100px">
                        <a-select-option value=""> 全部 </a-select-option>
                        <a-select-option value="01"> 南京研发中心 </a-select-option>
                        <a-select-option value="02"> 苏州研发中心 </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item>
                    <a-button @click="updateRoute" type="primary" htmlType="submit" :key="this.loading.key">筛选
                    </a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>

        <!-- 系统列表 -->
        <a-table :columns="columns" :data-source="data" :pagination="false" :loading="tLoading" rowKey="id" :scroll="{ x: clientWidth}">
            <span slot="ownercode" slot-scope="text">{{
        text == "01" ? "南京研发中心" : "苏州研发中心"
      }}</span>
            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <span>
                        <router-link :to="{
                path: '/system/domainurl',
                query: {
                  syscode: record.syscode,
                },
              }">运维创建</router-link>
                    </span>
                    <span>
                        <router-link :to="{
                path: 'edit',
                query: {
                  syscode: record.syscode,
                },
              }">编辑</router-link>
                    </span>
                    <span>
                        <a class="tableLink" href="javascript:;" @click="handleRelatedPlatforms(record)">关联平台</a>
                    </span>
                    <span>
                        <a-popconfirm title="确认删除?" @confirm="() => onSysDelete(record)">
                            <a>删除</a>
                        </a-popconfirm>
                    </span>
                </div>
            </template>
        </a-table>

        <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />
        <authE ref="autheEID" @handleCommit="handleCommit"></authE>
    </div>

</template>
<script>
import authE from './auth'
let searchP = {
    syscode: '', //系统编码
    sysname: '', //系统名称姓名
    ownercode: '', //所属组织
    syscategory: '', //分类
    version: '',
    domain: '', //领域
    sysadmin: '', //负责人
    total: 0,
    pageSize: 10,
    page: undefined,
}

const columns = [
    {
        title: '序号',
        width: 80,
        align: 'center',
        customRender: (text, record, index) => {
            let { page, pageSize } = searchP
            return (Number(page) - 1) * Number(pageSize) + index + 1
        },
    },
    {
        title: '领域',
        dataIndex: 'domainname',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'domainname' },
    },
    {
        title: '系统编码',
        dataIndex: 'syscode',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'syscode' },
    },
    {
        title: '版本',
        dataIndex: 'version',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'version' },
    },
    {
        title: '英文简称',
        dataIndex: 'sysenname',
        width: 200,
        align: 'center',
        scopedSlots: { customRender: 'sysenname' },
    },
    {
        title: '名称',
        dataIndex: 'sysname',
        width: 120,
        align: 'center',
        scopedSlots: { customRender: 'sysname' },
    },
    {
        title: '产品经理',
        dataIndex: 'sysproducter',
        width: 100,
        align: 'center',
        scopedSlots: { customRender: 'sysproducter' },
    },
    {
        title: '开发语言',
        dataIndex: 'syslanguage',
        width: 100,
        align: 'center',
        scopedSlots: { customRender: 'syslanguage' },
    },
    {
        title: '负责人',
        dataIndex: 'sysadmin',
        width: 100,
        align: 'center',
        scopedSlots: { customRender: 'sysadmin' },
    },
    {
        title: '系统分类',
        dataIndex: 'syscategory',
        width: 120,
        align: 'center',
        scopedSlots: { customRender: 'syscategory' },
    },
    {
        title: '所属组织',
        dataIndex: 'ownercode',
        width: 120,
        align: 'center',
        scopedSlots: { customRender: 'ownercode' },
    },
    {
        title: '关联平台',
        dataIndex: 'platformtypenames',
        width: 120,
        align: 'center',
    },
    {
        title: '备注',
        dataIndex: 'remark',
        width: 120,
        align: 'center',
        scopedSlots: { customRender: 'remark' },
    },
    {
        title: '操作',
        dataIndex: 'operation',
        width: 200,
        align: 'center',
        fixed: 'right',
        scopedSlots: { customRender: 'operation' },
    },
]

const data = []

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            editingKey: '',
            tLoading: true,
            searchP: searchP,
            clientWidth: 800,
        }
    },
    methods: {
        handleCommit() {
            this.updateRoute()
        },
        handleRelatedPlatforms(record) {
            this.$refs.autheEID.showModal({
                syscode: record.syscode,
                sysname: record.sysname,
            })
        },
        getSysList() {
            this.tLoading = true
            let c_params = this.searchP
            this.$store
                .dispatch({
                    type: 'sys/selectSys',
                    params: c_params,
                })
                .then((res) => {
                    this.tLoading = false
                    let result = res.data.data
                    this.data = result.list
                    this.searchP.total = result.totalRecords
                    this.searchP.pageSize = result.pageSize
                    this.searchP.page = result.page
                })
        },
        handlePageChange(c_p) {
            this.searchP.page = c_p
            this.updateRoute()
        },
        updateRoute() {
            //debugger
            /*             this.$router.push({
                 query: {
                    syscode: this.searchP.syscode,
                    version: this.searchP.version,
                    sysname: this.searchP.sysname,
                    ownercode: this.searchP.ownercode,
                    syscategory: this.searchP.syscategory,
                    domain: this.searchP.domain,
                    sysadmin: this.searchP.sysadmin,
                    page: this.searchP.page,
                }, 
            }) */
            this.getSysList()
        },
        handleSearchReset() {
            this.searchP.page = 1
            this.searchP.syscode = '' //系统编码
            this.searchP.sysname = '' //系统名称姓名
            this.searchP.ownercode = '' //所属组织
            this.searchP.syscategory = '' //分类
            this.searchP.domain = '' //领域
            this.searchP.sysadmin = '' //负责人
            this.searchP.version = '' //负责人
            this.updateRoute()
        },
        handleNewSys() {
            this.$router.push({
                path: 'add',
                query: { id: '' },
            })
        },
        refreshAppVersion() {
            this.tLoading = true
            this.$store
                .dispatch({
                    type: 'sys/refreshAppVersion',
                    params: {},
                })
                .then((res) => {
                    console.log(res)
                    this.tLoading = false
                })
        },
        handleSubmit(e) {
            e.preventDefault()
            this.searchP.page = 1
            this.updateRoute()
        },

        onSysDelete(key) {
            this.$store
                .dispatch({
                    type: 'sys/deleteSys',
                    params: { ...key },
                })
                .then((res) => {
                    if (res.status == '200') {
                        this.getSysList()
                    }
                })
        },
    },
    components: {
        authE,
    },
    watch: {
        $route() {
            this.$router.go(0)
        },
    },
    mounted() {
        /*         let query = this.$route.query
        this.searchP.syscode = query.syscode ? query.syscode : ''
        this.searchP.sysname = query.sysname ? query.sysname : ''
        this.searchP.ownercode = query.ownercode ? query.ownercode : ''
        this.searchP.syscategory = query.syscategory ? query.syscategory : ''
        this.searchP.domain = query.domain ? query.domain : ''
        this.searchP.sysadmin = query.sysadmin ? query.sysadmin : ''
        this.searchP.version = query.version ? query.version : ''
        this.searchP.page = query.page ? +query.page : 1 */
        this.getSysList()
    },
}
</script>
<style scoped>
.editable-row-operations a {
    margin-right: 8px;
}

td {
    padding: 10px 10px;
}
.tableLink {
    margin-right: 10px;
}
</style>
